import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot } from '@/fontawesome';
import type { ChatMessage } from '@/models/chat-message';

interface AssistantIntermediateMessageProps {
  message: ChatMessage;
}

export default function AssistantIntermediateMessage({ message }: AssistantIntermediateMessageProps) {
  return (
    <div className="my-3">
      <div className="bg-gray-100 dark:bg-gray-700 rounded-lg p-3 w-full">
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            <FontAwesomeIcon icon={faRobot} className="w-4 h-4 text-gray-600 dark:text-gray-400" />
          </div>
          <div className="flex-1">
            <div className="text-sm font-medium text-gray-800 dark:text-gray-200 mb-1">
              Intermediate Response
            </div>
            <div className="text-sm text-gray-600 dark:text-gray-400 italic">
              {message.content || '(Intermediate Response)'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}